import { SET_ADMIN_PRODUCTS, ADD_ADMIN_PRODUCT, UPDATE_ADMIN_PRODUCT, DELETE_ADMIN_PRODUCT } from './actions';

// Initial State
const INITIAL_STATE = [];

const productReducer = (state = INITIAL_STATE, action) => {
     switch (action.type) {
          case ADD_ADMIN_PRODUCT: {
               const newProducts = [...state];
               newProducts.push(action.payload);
               return newProducts;
          }

          case SET_ADMIN_PRODUCTS: {
               return action.payload;
          }

          case UPDATE_ADMIN_PRODUCT: {
               const newProducts = [...state];
               const _newProducts = newProducts.map((product) => {
                    if (product.id === action.payload.id) {
                         return { ...product, ...action.payload };
                    }
                    return product;
               });
               return _newProducts;
          }

          case DELETE_ADMIN_PRODUCT: {
               const newProducts = [...state];
               return newProducts.filter((product) => product.id !== action.payload);
          }

          default:
               return state;
     }
};

export const getProductById = (state, pid) => state.admin.products.filter((product) => product.id === pid)[0];

export default productReducer;
